import React from 'react'
import PropTypes from 'prop-types'
import { regItemProps } from '../reg-item-props'
import ContributorProductRegItemCard from './contributor-product-reg-item-card'
import ReservableProductRegItemCard from './reservable-product-reg-item-card'

export const ProductRegItemCard = ({
  filters,
  giftStatusContent,
  isContributorView,
  openRedirectModal,
  openReservationModal,
  regItem,
  reservationByCurrentVisitor,
}) =>
  isContributorView ? (
    <ContributorProductRegItemCard
      giftStatusContent={giftStatusContent}
      regItem={regItem}
    />
  ) : (
    <ReservableProductRegItemCard
      filters={filters}
      giftStatusContent={giftStatusContent}
      openReservationModal={openReservationModal}
      regItem={regItem}
      reservationByCurrentVisitor={reservationByCurrentVisitor}
      openRedirectModal={openRedirectModal}
    />
  )

ProductRegItemCard.propTypes = {
  filters: PropTypes.object,
  isContributorView: PropTypes.bool,
  giftStatusContent: PropTypes.string,
  openRedirectModal: PropTypes.func.isRequired,
  openReservationModal: PropTypes.func.isRequired,
  regItem: PropTypes.shape(regItemProps).isRequired,
  reservationByCurrentVisitor: PropTypes.object,
}

ProductRegItemCard.defaultProps = {
  filters: {},
  giftStatusContent: null,
  isContributorView: false,
  reservationByCurrentVisitor: null,
}

export default ProductRegItemCard
